import React, { useState, useRef, useImperativeHandle } from "react";
import { Popconfirm, Tooltip, theme } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  PlusCircleFilled,
} from "@ant-design/icons";
import TSTable from "../../../common/TSTable";
import ColorButton from "../../../common/ColorButton";
import { DELETE } from "../../../frameworks/HttpClient";
import { URL_SETTING } from "../../../constants/urls";
import SellLatexCCTModal from "./SellLatexCCTModal";
import { dateToHumanString } from "../../../frameworks/Util";
import ErrorMessages from "../../../common/ErrorMessages";
import CustomDeleteConfirmButton from "../../../common/CustomDeleteConfirmButton";

const SellLatexCCTList = React.forwardRef((props, ref) => {
  const { isDone } = props;
  const [openAddSellLatexCCTModal, setOpenAddSellLatexCCTModal] =
    useState(false);
  const [target, setTarget] = useState(null);
  const tableRef = useRef(null);
  const [errorMessages , setErrorMessages] = useState(null);

  const {
    token: { colorWarning, colorError, colorSuccess },
  } = theme.useToken();

  useImperativeHandle(ref, () => ({
    fetchTable: refreshData,
  }));
  const refreshData = async () => {
    if (tableRef.current) {
      setErrorMessages(null);
      try {
        await tableRef.current.fetchWithoutResetPage();
      } catch (error) {
        setErrorMessages (error.errorMessages);
      }
    }
  };
  const handleEdit = (record) => {
    if (!record || !record.id) {
      return;
    }
    setTarget(record);
    setOpenAddSellLatexCCTModal(true);
  };
  const handleDelete = async (id) => {
    if (!id) {
      return;
    }
    setErrorMessages(null);

    try {
      await DELETE(`${URL_SETTING.SELLER_CCT_LATEX}${id}/`);
      refreshData();
    } catch (error) {
      setErrorMessages (error.errorMessages);
    }
  };

  const columns = [
    {
      title: "Action",
      dataIndex: "",
      width: 200,
      key: "action",
      align: "center",
      render: (_, record) =>
        isDone ? null : (
          <div onClick={(e) => e.stopPropagation()}>
            <CustomDeleteConfirmButton
              title={`ยืนยันลบหรือไม่`}
              content={"ยืนยันการลบรายการนี้หรือไม่ ?"}
              onOk={ async() => {
                await handleDelete(record.id)
                refreshData();
              }}
              onConfirm={() => refreshData()}
            />
            <Tooltip triger='hover' title="แก้ไขข้อมูล">
              <ColorButton
                type="primary"
                override={colorWarning}
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
                style={{ margin : 5}}
              />
            </Tooltip>
          </div>
        ),
    },
    {
      title: "รหัส",
      dataIndex: "code",
      key: "code",
      searcher: true,
      align: "center",
    },
    {
      title: "ชื่อโรงงาน",
      dataIndex: "name",
      key: "name",
      align: "center",
      searcher: true,
    },
    {
      title: "ที่อยู่",
      dataIndex: "address",
      key: "address",
      align: "center",
    },
    {
      title: "เบอร์โทรศัพท์",
      dataIndex: "phone",
      key: "phone",
      align: "center",
    },
    {
      title: "วันที่สร้าง",
      dataIndex: "created",
      key: "created",
      align: "center",
      render : (value) => dateToHumanString(value)
    },
    {
      title: "วันที่แก้ไขล่าสุด",
      dataIndex: "updated",
      key: "updated",
      align: "center",
      render : (value) => dateToHumanString(value)
    }
  ];

  return (
    <div>
      <ErrorMessages message={errorMessages}/>
      <ColorButton
        type="primary"
        override={colorSuccess}
        icon={<PlusCircleFilled />}
        style={{ marginBottom: 10, float: "right" }}
        onClick={() => setOpenAddSellLatexCCTModal(true)}
      >
        เพิ่มผู้ขายน้ำยางข้น
      </ColorButton>
      <TSTable
        columns={columns}
        size="small"
        url={`${URL_SETTING.SELLER_CCT_LATEX}`}
        ref={tableRef}
      />
      <SellLatexCCTModal
        open={openAddSellLatexCCTModal}
        onClose={() => {
          setOpenAddSellLatexCCTModal(false);
          setTarget(null);
        }}
        onUpdate={() => { 
          setOpenAddSellLatexCCTModal(false);
          setTarget(null);
          refreshData();
        }}
        target={target}
      />
    </div>
  );
});

export default SellLatexCCTList;
